import React, { Component } from 'react';
import { createApolloFetch } from 'apollo-fetch';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import * as compose from 'lodash.flowright';
import { gql } from 'apollo-boost';

import {CREATE_JOB , EDIT_JOB , DELETE_QUESTION , EDIT_QUESTION , UPDATE_JOP} from './apis';
import {name} from '../../../validations/validation';

// styles , icons and images
import { Container, Row, Col, Modal, Form } from 'react-bootstrap';
import { InputLabel, IconButton, Button, InputBase, Typography, Tooltip } from '@material-ui/core';
import Loader from 'react-loader-spinner';
import AddIcon from '@material-ui/icons/Add';
import more from '../../../images/more.png';

// this component represents the questions part of the create and edit visume page

class JobQuestions extends Component {
    constructor() {
        super();
        this.state = {
            questionInputs: [],
            questions: [],
            inputs: [],
            yourQuetions: "",
            show: false,
            toggle: false,
            deleted: false,
            mandatory: true
        }
    }
    componentWillReceiveProps(props, nextProps) {
        if (props !== nextProps && props.data) {
            this.setState({
                ...this.state,
                id: props.data.jobId ? props.data.jobId : '',
                questions: props.data.questions ? props.data.questions : ''
            })
        }
    }
    componentDidMount() {
        let add = document.querySelector(".custom-input button");
        // when add new question
        add.addEventListener("click", function () {
            let allQuestions = document.querySelectorAll('.job-question-title');
            let flag;
            for (let i = 0; i < allQuestions.length; i++) {
                if (allQuestions[i].textContent.trim() === this.state.title.trim()) {
                    flag = 0;
                }
            }
            if(!this.state.errorMessage){

                if (flag === 0) {
                    this.setState({ ...this.state, errorMessage: 'This field  is already exist' });
                    return false;
                }
                else if (allQuestions.length >= 5) {
                    this.setState({ ...this.state, errorMessage: 'The limit of questions for each Visume is 5.' });
                    return false;
                }
                else{
                    this.setState({ ...this.state, errorMessage: '' });
                    // make a list 
                    let inputValue = document.querySelector(".custom-input input").value;
                    // let questionInputs = { title: inputValue, maximum_time: 60, minimum_time: 0, mandatory: true, ordering: 0 }
                    let questionInputs = { title: inputValue}
                    this.setState({ ...this.state, questions: [...this.state.questions, questionInputs], title: "" });
                    return true;
                }
            }
        }.bind(this));

    }
    handleBackBtn = () => {
        let list = document.getElementById("job-tabs");
        let nav_items = list.querySelectorAll(".nav-item a");
        nav_items[0].click();
    }
    handleClick = (e) => {
        let elem = e.currentTarget;
        if (elem.querySelector('.custom-list')) {
            elem.querySelector('.custom-list').classList.toggle('d-none')
        }
    }
    handleDelete = (e) => {
        if (e.target.getAttribute('data-id')) {
            let id = e.target.getAttribute('data-id');
            this.handleDeleteFromServer(id);
        }
        else {
            let questionToDelete = e.target.closest('.questionParent').querySelector('.job-question-title p').innerHTML;
            let questionsAfterDelete = this.state.questions.filter(question => question.title !== questionToDelete);
            this.setState({...this.state , questions : questionsAfterDelete})
            //  e.currentTarget.closest('.questionParent').classList.add('v-hidden');
            //  document.querySelector('.custom-ol .v-hidden').remove();
             this.HandleRemoveIssue();
        }
    }
    // **** handle removeChild issue *** //
    // (Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.) 
    HandleRemoveIssue = () => {
        if (typeof Node === 'function' && Node.prototype) {
            const originalRemoveChild = Node.prototype.removeChild;
            Node.prototype.removeChild = function (child) {
                if (child.parentNode !== this) {
                    if (console) {
                        console.error('Cannot remove a child from a different parent', child, this);
                    }
                    return child;
                }
                return originalRemoveChild.apply(this, arguments);
            }

            const originalInsertBefore = Node.prototype.insertBefore;
            Node.prototype.insertBefore = function (newNode, referenceNode) {
                if (referenceNode && referenceNode.parentNode !== this) {
                    if (console) {
                        console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
                    }
                    return newNode;
                }
                return originalInsertBefore.apply(this, arguments);
            }
        }
    }// end of handle code
    fetchJob = () => {
        if (localStorage.jwt) {
            const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
            const uri = 'https://spreago.black-squares.com/graphql';
            let id = JSON.parse(localStorage.jwt).user.id;
            const apolloFetch = createApolloFetch({ uri });
            apolloFetch.use(({ request, options }, next) => {
                if (!options.headers) {
                    options.headers = {};  // Create the headers object if needed.
                }
                options.headers['authorization'] = `Bearer ${token}`;

                next();
            });
            //get user data

            console.log(UPDATE_JOP)
            console.log(this.state)
            apolloFetch({
                query:`
                query($id : Int!){
                    jobFind(id : $id){
                      id
                      job_status { id name}
                      job_type { id name}
                      job_level_of_experience_type { id name}
                      title
                      brif
                      salary{ salary_from salary_to currency_type{id}}
                      is_Draft
                      if_user_apply
                      if_user_save
                      tags { id name}
                      questions {
                        id title 
                      }
                    }
                  }`,
                 variables: {
                    id: this.state.id
                }
            }).then(res => {
                console.log(res)
                if (res.data.jobFind) {
                    let data = res.data.jobFind;
                    let tags = data.tags.map(tag=>tag.name);

                    let filterdData = {
                        jobId : data.id,
                        brief: data.brif,
                        experience: data.job_level_of_experience_type.id,
                        jobStatus: data.job_status,
                        jobType: data.job_type.id,
                        salaryFrom: data.salary.salary_from,
                        salaryTo: data.salary.salary_to,
                        currency: data.salary.currency_type.id,
                        tagsChoosen: tags,
                        title: data.title,
                        questions : data.questions
                    }
                    console.log(filterdData);
                    this.props.callBackFun(filterdData)
                    this.setState({ ...this.state, questions: res.data.jobFind.questions })
                }
            }).catch((err) => console.log(err));
        }
    }
    handleEditQuestion = (e) => {
        // get index of question you want to edit
        let items = document.querySelectorAll(".custom-ol .questionParent .job-question-title p"),
            tab = [], index;
        for (var i = 0; i < items.length; i++) {
            tab.push(items[i].innerHTML);
        }
        index = tab.indexOf(e.currentTarget.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('.job-question-title').textContent);
        let questionToEdit = e.currentTarget.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('.job-question-title').textContent;
        this.setState({ ...this.state, questionToEdit: questionToEdit, questionAfterEdit: questionToEdit, indexOfEdit: index, show: true })

    }
    // toggleChecked = (e) => {
    //     let x = this.state.mandatory;
    //     this.setState({ ...this.state, mandatory: !x });
    // };
    handleDeleteFromServer = (id) => {

        this.props.deleteQuestion({
            variables: {
                question_id: parseInt(id),
            }
        }).then((res, loading) => {
            if (res.data.questionDelete.Status.code === 200) {
                this.fetchJob()
            }
        }).catch((err) => {
            console.log(err)
        }
        )
    }
    checkquestion = (listOfQuestions) => {
        if (listOfQuestions.length < 1) {
            this.setState({ ...this.state, errorMessage: 'You must enter at least one question' });
            return false;

        } else {
            this.setState({ ...this.state, errorMessage: '' });
            return true;
        }
    }
    handleCreateAndEditJob = (isDraft) => {
    
        let jobInputs = this.props.data; 
        let salaryInput = {currency_type_id : jobInputs.currency , salary_from : parseInt(jobInputs.salaryFrom) , salary_to : parseInt(jobInputs.salaryTo)}
        // if(this.checkquestion(this.state.questions)) {
            // create job
            if(!jobInputs.jobId){ 
                    this.props.createJob({
                        variables :{
                            title : jobInputs.title,
                            job_type_id : jobInputs.jobType,
                            job_level_of_experience_type_id : jobInputs.experience,
                            brif :  jobInputs.brief,
                            salaryInput : salaryInput,
                            tags : jobInputs.tagsChoosen,
                            questionInputs : this.state.questions,
                            is_Draft : isDraft
                        }
                    }).then((res,) => {
                        if (res.data.jobCreate.Status.check ) {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            this.props.history.push({
                                pathname: '/jobs'
                            })
                        }
                    }).catch((err) =>
                        console.log(err)
                        //  this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." })
                    )
            } // edit job
            else{
                console.log("in")
                let newQuestions = this.state.questions.filter(question => !question.id);
                let editQuestions = this.state.questions.filter(question => question.id);

                // edit questions
                editQuestions.map(question => {
                let id = question.id;
                delete question.id;
                this.props.editQuestion({
                    variables: {
                        question_id: id,
                        questionInputs: question,
                    }
                }).then((res, loading) => {
                    if (res.data.questionEdit.Status.code === 200) {
                    }
                }).catch((err) =>
                    console.log(err)
                    //  this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." })
                    )
                })
                // edit job and add the new questions
                this.props.editJob({
                    variables : {
                        job_id : jobInputs.jobId,
                        title : jobInputs.title,
                        job_type_id : jobInputs.jobType,
                        job_level_of_experience_type_id : jobInputs.experience,
                        brif :  jobInputs.brief,
                        salaryInput : salaryInput,
                        tags : jobInputs.tagsChoosen,
                        add_question_inputs : newQuestions,
                        is_Draft : isDraft,
                        // 1 for published and 2 for closed !
                        job_status_id : isDraft == false ? 1 : 2
                    }
                }).then(res=>{
                        if (res.data.jobEdit.Status.check) {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            this.props.history.push({
                                pathname: '/jobs'
                            })
                        }
                }).catch(err=>console.log(err))

            }
        // }
    }
    render() {
        const handleChange = props => event => {
            this.setState({ ...this.state, [props]: event.target.value });
            if(props === 'title'){
                let error = name(event.target.value)
                this.setState({ ...this.state, [props]: event.target.value , errorMessage: error});  
            }
            else{
                this.setState({ ...this.state, [props]: event.target.value})
            }  
        };
        const handleClose = () => this.setState({ ...this.state, errorMessageEdit: '', show: false });

        return (
            <div className="pb-3">
                <Container className="job-question shadow border-rounded bg-white">
                    <Row>
                        <Col className=" border-bottom p-5 bg-light" sm={12}>
                            <div className="title">
                                <h4 className="text-dark">Questions</h4>
                                <p className="text-grey mb-0">Here you can add your questions with maximum duration 1min.</p>

                            </div>
                        </Col>
                        <Col className="text-dark p-5">
                            <InputLabel htmlFor="title">
                                Question Title<span className="text-danger"> *</span>
                            </InputLabel>
                            <div className="custom-input mt-1">
                                <InputBase
                                    placeholder="Write your question title"
                                    onChange={handleChange('title')}
                                    id="title"
                                    name="title"
                                    value={this.state.title}
                                    className="w-90 pl-2"
                                />
                                <IconButton color="primary" className="offset-8" aria-label="directions">
                                    <AddIcon />
                                </IconButton>
                            </div>
                            <Col xs={12} className="p-0 pb-4">
                                <Typography variant="subtitle1" className="text-danger">{this.state.errorMessage}</Typography>
                            </Col>
                            <div><p className="mb-0">Your Questions<span className="border-b-1"></span></p></div>
                            <div className=" text-dark pt-2 pb-2">
                                <ol className="w-100 pl-0 custom-ol">
                                    {console.log(this.state)}
                                    {(this.state.questions) ?
                                        this.state.questions.map(input =>
                                            <Row className="bg-lightgrey m-0 pt-2 pb-2 mt-1  questionParent">
                                                <Col sm={1} xs={1} className="dots mr-3-responsive">
                                                    <button
                                                        type="button"
                                                        className="more-btn"
                                                        onClick={this.handleClick}>
                                                        <ul data-id={(input.id) ? input.id : ''} className="shadow custom-list d-none">
                                                            <li className="list-style-none p-0 text-center edit-option">
                                                                <button
                                                                    type="button"
                                                                    onClick={this.handleEditQuestion}
                                                                    className="bg-transparent border-0 w-100 pt-1 pb-1 pr-3 pl-3" >
                                                                    Edit
                                                                    </button>
                                                            </li>
                                                            <li className="list-style-none text-center delete-option p-0">
                                                                <button
                                                                    data-id={(input.id) ? input.id : ''}
                                                                    type="button"
                                                                    onClick={this.handleDelete}
                                                                    className="bg-transparent border-0 pt-1 pb-1 pr-3 pl-3">Delete</button>
                                                            </li>
                                                        </ul>
                                                        <img src={more} alt="more" />
                                                    </button>
                                                </Col>
                                                <Col xs={10} className="p-0">
                                                    <li className="w-100">
                                                        <Col
                                                            xs={12}
                                                            data-id={(input.id) ? input.id : ''}
                                                            className="p-0 text-left job-question-title"
                                                            >
                                                            <p className="mb-0">{input.title}</p>
                                                        </Col>
                                                        {/* <Row className="m-0"> */}
                                                            {/* <Col
                                                                xs={9}
                                                                data-id={(input.id) ? input.id : ''}
                                                                className="p-0 text-left job-question-title"
                                                            >
                                                                <p className="mb-0">{input.title}</p>
                                                                </Col> */}
                                                            {/* <Col sm={3} xs={3} className="p-0 text-right">
                                                                <Tooltip title="Required">
                                                                    <Form.Check
                                                                        className=""
                                                                        type="switch"
                                                                        onChange={e => {
                                                                            e.target.value = e.target.checked ? true : false;
                                                                            let text = e.target.parentNode.parentNode.parentNode.querySelector('.job-question-title p').textContent;

                                                                            let row = this.state.questions?.filter(question => question.title === text);
                                                                            let allQuestions = this.state.questions?.filter(question => question.title !== text);
                                                                            row[0].mandatory = !!JSON.parse(String(e.target.value).toLowerCase());
                                                                            console.log(allQuestions);
                                                                            allQuestions.push(row[0]);
                                                                            console.log(allQuestions)
                                                                            
                                                                        }}
                                                                        id={Math.random()}
                                                                        label=""
                                                                        defaultChecked={input.id ? input.mandatory === 1 ? true : false : true}
                                                                    />
                                                                </Tooltip>
                                                            </Col> */}
                                                        {/* </Row> */}
                                                    </li>
                                                </Col>
                                            </Row>
                                        ) : ''}
                                    <Modal className="modal-edit row m-0 " show={this.state.show} onHide={handleClose}>
                                        <Col xs={12}>
                                            <Modal.Header closeButton>
                                                <Modal.Title className="h6">Edit Question</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <InputLabel htmlFor="title">
                                                    Question Title<span className="text-danger"> *</span>
                                                </InputLabel>
                                                <div className="custom-input  mt-1 pl-2">
                                                    <InputBase
                                                        className="inputToEdit w-100"
                                                        placeholder="Write your question title"
                                                        onChange={handleChange('questionAfterEdit')}
                                                        id="title"
                                                        name="title"
                                                        defaultValue={this.state.questionToEdit}
                                                    />
                                                </div>
                                                <Col xs={12} className="p-0 pb-1">
                                                    <Typography variant="subtitle1" className="text-danger">{this.state.errorMessageEdit}</Typography>
                                                </Col>
                                            </Modal.Body>
                                            <Modal.Footer className="custom">
                                                <Button 
                                                    type="button" 
                                                    size="small" 
                                                    className="btn-orange-gradiant" 
                                                    variant="contained" 
                                                    onClick={() => {
                                                        // validation of question
                                                        let allQuestions = document.querySelectorAll('.job-question-title');
                                                        let flag = 1;
                                                        for (let i = 0; i < allQuestions.length; i++) {
                                                            if (i !== this.state.indexOfEdit) {
                                                                if (allQuestions[i].textContent === this.state.questionAfterEdit) {
                                                                    flag = 0;
                                                                }
                                                            }
                                                        }
                                                        if (name(this.state.questionAfterEdit)) {
                                                            let error = name(this.state.questionAfterEdit);
                                                            this.setState({ ...this.state, errorMessageEdit: error });
                                                            return false;
                                                        }
                                                        else if (flag === 0) {
                                                            this.setState({ ...this.state, errorMessageEdit: 'This field  is already exist' });
                                                            return false;
                                                        }
                                                        else {
                                                            this.setState({ ...this.state, errorMessageEdit: '' });

                                                            let row = this.state.questions?.filter(question => question.title === this.state.questionToEdit);
                                                            let allQuestions = this.state.questions?.filter(question => question.title !== this.state.questionToEdit);
                                                            row[0].title = this.state.questionAfterEdit;
                                                            allQuestions.push(row[0]);
                                                            this.setState({ ...this.state, questions: allQuestions })

                                                            // let newvalue = document.querySelector('.inputToEdit input').value;
                                                            // let Questions = document.querySelectorAll('.job-question-title');
                                                            // Questions[this.state.indexOfEdit].querySelector('p').innerHTML = newvalue;
                                                            handleClose();
                                                        }
                                                    }}>
                                                    Save Changes
                                                </Button>
                                            </Modal.Footer>
                                        </Col>
                                    </Modal>
                                </ol>
                            </div>
                            <Col xs={12} className="pb-3">
                                <Typography variant="subtitle1" className="text-danger">{this.state.ConnectionErorr}</Typography>
                            </Col>
                        </Col>
                    </Row>
                </Container>
                <div className="row m-0 w-100">
                    <Col xs="7" className="d-inline-block p-0 pt-4 text-left pt-2">
                        <Tooltip  title="if you click back, you will lose the question you just entered.">
                            <Button
                                type="button"
                                onClick={this.handleBackBtn}
                                size="large"
                                className="btn-white-outline pr-5 pl-5"
                                variant="contained"
                            >Back</Button>
                        </Tooltip>
                    </Col>
                    <Col xs="5" className="d-inline-block p-0 pt-4 text-right ">
                        <Row className="m-0">
                            <Col md={6} className="p-0 text-right text-center pt-2">
                                <Button
                                    size="large"
                                    className="btn-white-outline pr-4 pl-4"
                                    variant="contained"
                                        onClick={e => 
                                            this.handleCreateAndEditJob(true)
                                        }
                                >
                                    Save As Draft
                                </Button>
                            </Col>
                            <Col md={6} className="p-0 pt-2 text-center">
                                <Button
                                    size="large"
                                    className="btn-orange-gradiant question-next pr-5 pl-5"
                                    variant="contained"
                                    onClick={e => this.handleCreateAndEditJob(false) }
                                >Publish</Button>
                            </Col>
                        </Row>
                    </Col>
                </div>
            </div>
        );
    }
}





export default compose(
    graphql(CREATE_JOB, {
        name: "createJob"
    }),
    graphql(EDIT_JOB, {
        name: "editJob"
    }),
    graphql(EDIT_QUESTION, {
        name: "editQuestion"
    }),
    graphql(DELETE_QUESTION, {
        name: "deleteQuestion"
    }),
)(withRouter(JobQuestions));